<template>
  <v-autocomplete
      v-model="options"
      :items="list"
      :item-text="getNcDeptName"
      item-value="code"
      :rules="rules"
      :label="unitcode?label:'请选择签约公司'"
      placeholder="请选择签约公司"
      :disabled="disabled || !unitcode"
      dense
      outlined
  ></v-autocomplete>

</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";

export default {
  name: "NcDeptSelect",
  data:()=>({
    corpList:[],
    list:[],
    corpCode:''
  }),
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    },
    disabled:{
      type:Boolean,
      default: false
    },
    unitcode:{
      type:String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  watch:{
    unitcode(val){
      this.listNcDept(val);
    }
  },
  computed: {
    options: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
  },
  created() {
    if(this.unitcode){
      this.listNcDept(this.unitcode);
    }
  },
  methods: {
    getNcDeptName(dept){
      return `${dept.name}(${dept.code})`;
    },
    listNcDept(unitcode){
      let me = this;
      ContractApi.listNcDept({unitcode:unitcode}).then(data=>{
        me.list = data;
      })
    },
  }
}
</script>

<style scoped>

</style>